import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";

/**
 * CLass for context menu for enable/disable Inflight Checks - state.available false by default, state.enabled is true
 */
export class BfxBlotterOrdersContextMenuInflightCheck extends BfxBlotterOrdersContextMenuItem {
  constructor(
    public actionId: BfxBlotterAction,
    title: string,
    inclusionState: CubiqTS.InflightInclusionState,
  ) {
    super(
      actionId,
      title,
      BfxBlotterOrdersContextMenuInflightCheck.checkAvailableFn(),
      BfxBlotterOrdersContextMenuInflightCheck.checkEnabledFn(inclusionState),
      ContextMenuItemStateCommandCriteria.Item,
      ContextMenuItemStateCommandCriteria.Item,
    );
    this.state.enabled = true;
  }

  public override reset(): void {
    super.reset();
    this.state.enabled = true;
  }

  /**
   * Always starts off as unavailable - we'll only add it if any selected orders are algos
   * @param this
   * @param menuState
   * @param itemState
   * @param item
   */
  private static checkAvailableFn() {
    return (
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) => {
      itemState.available =
        itemState.available ||
        (item != null &&
          (item.orderType == CubiqTS.OrderType.ALGO ||
            item.orderType == CubiqTS.OrderType.BMALGO) &&
          menuState.canChangeInflightStatus);
    };
  }

  /**
   * Enabled starts off as true and is set to false is any item fails inclusion check.
   * This is a factory method for the check so pass through the incusion state
   */
  private static checkEnabledFn(inclusionState: CubiqTS.InflightInclusionState) {
    return (
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) => {
      itemState.enabled =
        itemState.enabled &&
        item != null &&
        (item.orderType === CubiqTS.OrderType.ALGO ||
          item.orderType === CubiqTS.OrderType.BMALGO) &&
        (item.orderState === CubiqTS.OrderState.ACTIVE ||
          item.orderState === CubiqTS.OrderState.PENDING) &&
        item.inflightInclusionState === inclusionState;
    };
  }
}
